import type { SettingDefinition, SettingsSource } from '../models/settings-hub.model';

import { INTERFACE_SUBCATEGORY } from './advanced.registry';
import { CASHREGISTER_SUBCATEGORY } from './cashregister.registry';
import { CUSTOMER_DISPLAY_SUBCATEGORY } from './customer-display.registry';
import { CUSTOMERS_SUBCATEGORY } from './customers.registry';
import { DELIVERY_SUBCATEGORY } from './delivery.registry';
import { EINVOICE_SUBCATEGORY } from './einvoice.registry';
import { GENERAL_SUBCATEGORY } from './general.registry';
import { LOCAL_COMMUNICATION_SUBCATEGORY, SCALES_SUBCATEGORY } from './hardware.registry';
import { AUTOMATIONS_SUBCATEGORY, HOSPITALITY_SUBCATEGORY, MARKETING_SUBCATEGORY, RETAIL_SUBCATEGORY } from './integrations.registry';
import { PAYMENTS_SUBCATEGORY } from './payments.registry';
import { NOTIFICATIONS_SUBCATEGORY, SECURITY_SUBCATEGORY } from './security.registry';
import { STOCK_SUBCATEGORY } from './stock.registry';


/** Where each setting was defined, by feature: the layout of the page does not follow this grouping, see `settings-layout.ts` */
const SOURCE_SUBCATEGORIES: SettingsSource[] = [
    GENERAL_SUBCATEGORY,
    CUSTOMER_DISPLAY_SUBCATEGORY,
    CASHREGISTER_SUBCATEGORY,
    PAYMENTS_SUBCATEGORY,
    CUSTOMERS_SUBCATEGORY,
    DELIVERY_SUBCATEGORY,
    EINVOICE_SUBCATEGORY,
    STOCK_SUBCATEGORY,
    LOCAL_COMMUNICATION_SUBCATEGORY,
    SCALES_SUBCATEGORY,
    SECURITY_SUBCATEGORY,
    NOTIFICATIONS_SUBCATEGORY,
    HOSPITALITY_SUBCATEGORY,
    MARKETING_SUBCATEGORY,
    RETAIL_SUBCATEGORY,
    AUTOMATIONS_SUBCATEGORY,
    INTERFACE_SUBCATEGORY
];

/**
 * Every setting by id. The rules of the subcategory and of the card that a setting was defined in (e.g. "only in Italy")
 * are folded into the rule of the setting, so it keeps them wherever the layout puts it.
 */
export const SETTINGS_POOL: ReadonlyMap<string, SettingDefinition> = new Map(
    SOURCE_SUBCATEGORIES.flatMap(subcategory =>
        subcategory.cards.flatMap(card =>
            card.settings.map((setting): [string, SettingDefinition] => {
                const rules = [subcategory.visibleWhen, card.visibleWhen, setting.visibleWhen].filter(rule => !!rule);

                return [setting.id, rules.length === 0 || (rules.length === 1 && rules[0] === setting.visibleWhen) ? setting : { ...setting, visibleWhen: context => rules.every(rule => rule!(context)) }];
            })
        )
    )
);
